// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__35Ei8","title":"InfoRow_title__3tjcG"};